import React from "react";
import { bindActionCreators } from "redux";
import { logout } from "../redux-stuffs/actions/token_action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import api from "../api/api/index";
import queryString from "query-string";
import {
    merchantAddressState,
    merchantNameState,
    nameState,
    phoneState,
    emailState,
    accessTokenState,
    amountState,
    loginOtpVerifyCount,
    loginOtpVerifyDate,
    themePreferenceState,
} from "../atoms";
import withRecoil from "../withRecoil";
import { withTranslation } from "react-i18next";
import LanguageSwitcher from '../container/LanguageSwitcher';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            profilePic: "",
            name: "",
            phone: "",
            email: "",
        };
        this.dropdownRef = React.createRef();
    }

    componentDidMount() {
        if (!this.props.token) {
            this.props.history.push({ pathname: "/" });
        } else {
            this.fetchProfilePic();
        }
        document.addEventListener("mousedown", this.handleClickOutside);
        document.addEventListener("touchstart", this.handleClickOutside);
    }

    componentWillUnmount() {
        clearInterval(this.profilePicInterval);
        document.removeEventListener("mousedown", this.handleClickOutside);
        document.removeEventListener("touchstart", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ isOpen: false });
        }
    };

    toggleDropdown = () => {
        this.setState((prev) => ({ isOpen: !prev.isOpen }));
    };

    logout = () => {
        this.props.logout().then(() => {
            this.props.recoilStates[merchantAddressState.key].setState("");
            this.props.recoilStates[merchantNameState.key].setState("");
            this.props.recoilStates[nameState.key].setState("");
            this.props.recoilStates[phoneState.key].setState("");
            this.props.recoilStates[emailState.key].setState("");
            this.props.recoilStates[amountState.key].setState("");
            this.props.recoilStates[accessTokenState.key].setState("");
            this.props.recoilStates[loginOtpVerifyCount.key].setState(0);
            this.props.recoilStates[loginOtpVerifyDate.key].setState("");
            this.props.history.push({ pathname: "/login" });
        });
    };

    toggleTheme = () => {
        const current = this.props.recoilStates[themePreferenceState.key]?.state || 'light';
        const next = current === 'dark' ? 'light' : 'dark';
        this.props.recoilStates[themePreferenceState.key].setState(next);
    };

    fetchProfilePic = () => {
        fetch(`${api.main}/access_token_login`, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
            body: queryString.stringify({
                access_token: this.props.token,
                device_type: 3,
                device_token: 1,
                app_version: 1,
            }),
        })
            .then((response) => {
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                return response.json();
            })
            .then((response) => {
                const isValidUrl = (str) => {
                    try {
                        new URL(str);
                        return true;
                    } catch {
                        return false;
                    }
                };
                this.setState({
                    name: response.data.name,
                    phone: response.data.phone,
                    email: response.data.email,
                });
                if (typeof response.data.profile_pic === "string" && isValidUrl(response.data.profile_pic)) {
                    this.setState({ profilePic: response.data.profile_pic });
                } else {
                    this.setState({
                        profilePic: "https://spare-app.s3.us-west-1.amazonaws.com/images/default_profile_pic.png",
                    });
                }
            })
            .catch(() => {
                this.props.history.push({ pathname: "login" });
            });
    };

    render() {
        const { t } = this.props;
        const currentTheme = this.props.recoilStates[themePreferenceState.key]?.state || 'light';
        const isDarkTheme = currentTheme === 'dark';

        return (
            <div className="navbar d-flex justify-content-between align-items-center">
                <div className="navbar-brand">
                    <a href="/dashboard" className="navbar-brand__link" aria-label={t("header:brand")}>
                        <img
                            src={`${process.env.PUBLIC_URL || ''}/images/spare_logo_s.png`}
                            alt={t("header:brand")}
                            className="navbar-brand__logo"
                        />
                        <span className="navbar-brand__text">{t("header:brand")}</span>
                    </a>
                </div>

                {/* Right side group */}
                <div className="ms-auto d-flex align-items-center gap-2">{/* Bootstrap 5: use ms-auto; for v4 use ml-auto and replace gap-2 with spacing utilities */}
                    <button
                        type="button"
                        className="theme-toggle"
                        onClick={this.toggleTheme}
                        aria-label={isDarkTheme ? t('header:switchToLight') : t('header:switchToDark')}
                    >
                        {isDarkTheme ? (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M12 4.5V2m0 20v-2.5m7.07-12.57l1.77-1.77M3.16 20.84l1.77-1.77M4.5 12H2m20 0h-2.5m-1.52 5.07l1.77 1.77M4.93 5.16l1.77 1.77M12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        ) : (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M21 14.5A8.5 8.5 0 0110.5 4a8.5 8.5 0 008.5 17 8.5 8.5 0 002-6.5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        )}
                    </button>
                    <LanguageSwitcher />

                    <div className="navbar-links d-flex align-items-center" ref={this.dropdownRef}>
                        <button
                            className="profile-pic border-0 bg-transparent"
                            aria-haspopup="menu"
                            onClick={this.toggleDropdown}
                            aria-label={t("header:openMenu")}
                        >
                            <img src={this.state.profilePic} alt={t("header:profileAlt")} className="rounded-circle" />
                        </button>

                        {this.state.isOpen && (
                            <div className="dropdown-menu active" role="menu" aria-label={t("header:menuLabel")}>
                                <div className="dropdown-header">
                                    <div style={{ display: "flex", justifyContent: "flex-start", alignContent: "center" }}>
                                        <img src={this.state.profilePic} alt={t("header:profileAlt")} className="dropdown-profile-pic" />
                                        <div className="dropdown-profile-info">
                                            <strong>{this.state.name}</strong>
                                            <p>{this.state.email}</p>
                                            <p>{this.state.phone}</p>
                                        </div>
                                    </div>
                                </div>

                                <ul className="dropdown-list">
                                    <li>
                                        <button onClick={() => this.props.history.push("/profile")}>
                                            {t("header:accountSettings")}
                                        </button>
                                    </li>
                                    {/* <li><button onClick={() => this.props.history.push('/dashboard')}>{t('header:dashboard')}</button></li> */}
                                    <li>
                                        <button onClick={() => this.props.history.push("/history")}>
                                            {t("header:transactionHistory")}
                                        </button>
                                    </li>
                                    <li>
                                        <button onClick={() => this.props.history.push("/help")}>{t("header:helpFaq")}</button>
                                    </li>
                                    <li>
                                        <button onClick={this.logout} style={{ color: "#ff4d4f" }}>
                                            {t("header:logout")}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            logout,
        },
        dispatch
    );

const mapStateToProps = (state) => ({
    token: state.token,
});

// wrap with i18n first, then withRouter/withRecoil/connect
const WrappedHeader = withTranslation(["header"])(Header);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    withRouter(
        withRecoil(WrappedHeader, [
            merchantAddressState,
            merchantNameState,
            nameState,
            phoneState,
            emailState,
            accessTokenState,
            amountState,
            loginOtpVerifyCount,
            loginOtpVerifyDate,
            themePreferenceState,
        ])
    )
);
